import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "@mui/material/SvgIcon";
import toast from "react-hot-toast";
import * as Icons from "@mui/icons-material";
import { useMenuPermissions } from "src/contexts/menu-permissions-context";


export const useSections = () => {
  const { i18n } = useTranslation();
  const { menuPermissions } = useMenuPermissions();
  const [menu, setMenu] = useState([]);
//alert(JSON.stringify( menuPermissions));
  useEffect(() => {
    try {
      if (!menuPermissions?.length) {
        setMenu([]);
        return;
      }

      const visibleMenus = menuPermissions
        .map((parent) => {
          const hasChildren = Array.isArray(parent.Items) && parent.Items.length > 0;
          const IconComponent = Icons[parent.Icon] || Icons["HelpOutline"];
          const visibleChildren = hasChildren
            ? parent.Items.filter((child) => child.CanView).map((child) => ({
                title: child.Title,
                path: child.Path,
                canAdd: child.CanAdd,
                canEdit: child.CanEdit,
                canDelete: child.CanDelete,
              }))
            : [];

          const isParentVisible =
            !(hasChildren && visibleChildren.length === 0 && parent.Items.length > 0);

          if (!isParentVisible) return null;

          const menuItem = {
            title: parent.Title,
            path: parent.Path || "#",
            icon: (
              <SvgIcon fontSize="small" component={IconComponent} />
            ),
            canAdd: parent.CanAdd,
            canEdit: parent.CanEdit,
            canDelete: parent.CanDelete,
          };

          if (visibleChildren.length > 0) {
            menuItem.items = visibleChildren;
          }

          return menuItem;
        })
        .filter(Boolean);

      setMenu(visibleMenus);
    } catch (err) {
      console.error("❌ Menu load error:", err);
      toast.error("Failed to load menu");
    }
  }, [menuPermissions, i18n.language]);

  return useMemo(() => [{ items: menu }], [menu]);
};
